module.exports = __webpack_public_path__ + "1791188489487/fonts/fa-regular-400.8d220c7.ttf";